import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { convertToAnalyticObject } from '../../utils/analytics';
import getListing from '../../utils/getListing';
import { qsToObject } from '../../utils/querystring';
import { usePrevious } from '../../utils/usePrevious';
import { eventDatesRange } from '../Listing/DateRange';
import { get, getPageThemeColors, getColorByTheme, canUseDOM, getDictionaryItem, replaceUrlPluses } from '../../utils';
import { getHostName } from '../atoms/InteractiveMap/utils/getHostName';
import addQueryString, { ANNUAL_FEE, convertQueryParamsToFacetsWithoutPlusReplacement, getAlgoliaTagsList, removeQueryString, splitter } from '../Listing';
import InteractiveGoogleMap from '../atoms/InteractiveMap/InteractiveGoogleMap';
import InteractiveMapFilters from '../atoms/InteractiveMap/InteractiveMapFilters';
import InteractiveMapListing from '../atoms/InteractiveMap/InteractiveMapListing';
import InteractiveMapLayout from '../atoms/InteractiveMap/InteractiveMapLayout';
import CategoryFilters from '../atoms/InteractiveMap/components/CategoryFilters';
import { getItemColor } from '../atoms/InteractiveMap/utils/getItemColor';
import { getTopPicksStorage } from '../atoms/FavouriteBtn/top_picks_apis';
import { idConverter } from '../atoms/FavouriteBtn/FavouriteBtn';
var filterType = 'type';
var withMapModalView = false;
var imageDictionary = 'imageDictionary';
export var moveObjectToFirstPlace = function moveObjectToFirstPlace(array, conditionFn) {
  var index = array.findIndex(conditionFn);
  if (index !== -1) {
    var _array$splice = array.splice(index, 1),
      _array$splice2 = _slicedToArray(_array$splice, 1),
      object = _array$splice2[0];
    array.unshift(object);
  }
  return array;
};
var getFacetNamesValue = function getFacetNamesValue(filterData) {
  if (filterData) {
    var values = filterData.values.map(function (filter) {
      var item1 = get(filter, 'fieldNameItem.item.fieldName.value');
      var item2 = get(filter, 'fieldNameItems.items.0.fieldName.value');
      var facet = item1 || item2 || 'datesRange';
      if (facet === 'maxDelegates') {
        return 'maxDelegatesRangeIndex';
      }
      return facet;
    });
    return values;
  } else {
    return [];
  }
};
var InteractiveMap = function InteractiveMap(_ref) {
  var fields = _ref.fields,
    children = _ref.children,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var language = sitecoreContext && sitecoreContext.language;
  var currentLang = get(sitecoreContext, 'language');
  var location = useLocation();
  var history = useHistory();
  // max number algolia can sent by 1 request
  var pagesize = 1000;
  var mainSearchIndex = get(fields, 'data.datasource.mainSearchIndex.jss.fields.IndexName.value', '');
  var mainHitsPerPage = get(fields, 'data.datasource.hitPerPage.jss.value', 10);
  var mainTitle = get(fields, 'data.datasource.title.jss.value') || '';
  var categories = get(fields, 'data.datasource.children') || [];
  var defaultMapZoom = Number(get(fields, 'data.datasource.defaultMapZoom.jss.value')) || 10;
  var centreMapLatitude = Number(get(fields, 'data.datasource.centreMapLatitude.jss.value')) || 25.2048493;
  var centreMapLongitude = Number(get(fields, 'data.datasource.centreMapLongitude.jss.value')) || 55.2707828;
  var dictionary = get(fields, 'data.dictionary');
  var _React$useState = React.useState({
      values: []
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    nestedFilters = _React$useState2[0],
    setNestedFilters = _React$useState2[1];
  var _React$useState3 = React.useState(),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    result = _React$useState4[0],
    setResult = _React$useState4[1];
  var _React$useState5 = React.useState(),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    defaultFacets = _React$useState6[0],
    setdefaultFacets = _React$useState6[1];
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    page = _React$useState8[0],
    setpage = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    resetFilter = _React$useState10[0],
    setResetFilter = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    setFilters = _React$useState12[0],
    applySetFilters = _React$useState12[1];
  var _React$useState13 = React.useState([]),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    chosenTypes = _React$useState14[0],
    setChosenTypes = _React$useState14[1];
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    removeFilterLogic = _React$useState16[0],
    setRemoveFilterLogic = _React$useState16[1];
  var _React$useState17 = React.useState(true),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    firstLoad = _React$useState18[0],
    setFirstLoad = _React$useState18[1];
  var _React$useState19 = React.useState([]),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    facets = _React$useState20[0],
    setFacets = _React$useState20[1];
  var _React$useState21 = React.useState({}),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    facetsStats = _React$useState22[0],
    setFacetsStats = _React$useState22[1];
  var _React$useState23 = React.useState(0),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    nbHits = _React$useState24[0],
    setNbHits = _React$useState24[1];
  var _React$useState25 = React.useState(0),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    nbPages = _React$useState26[0],
    setNbPages = _React$useState26[1];
  var _React$useState27 = React.useState([]),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    hits = _React$useState28[0],
    setHits = _React$useState28[1];
  var _React$useState29 = React.useState([]),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    allHits = _React$useState30[0],
    setAllHits = _React$useState30[1];
  var _React$useState31 = React.useState([]),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    listingHits = _React$useState32[0],
    setListingHits = _React$useState32[1];
  var _React$useState33 = React.useState(false),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    resetAllFilters = _React$useState34[0],
    setResetAllFilters = _React$useState34[1];
  var _React$useState35 = React.useState(false),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    loading = _React$useState36[0],
    setLoading = _React$useState36[1];
  var _React$useState37 = React.useState(false),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    mapApiReady = _React$useState38[0],
    setMapApiReady = _React$useState38[1];
  var _React$useState39 = React.useState({}),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    mapState = _React$useState40[0],
    setMapState = _React$useState40[1];
  var _React$useState41 = React.useState(true),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    isVdsite = _React$useState42[0],
    setIsVdsite = _React$useState42[1];
  var _React$useState43 = React.useState(false),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    allowSearch = _React$useState44[0],
    setAllowSearch = _React$useState44[1];
  var _React$useState45 = React.useState(null),
    _React$useState46 = _slicedToArray(_React$useState45, 2),
    activeListingItemId = _React$useState46[0],
    setActiveListingItemId = _React$useState46[1];
  var _React$useState47 = React.useState(false),
    _React$useState48 = _slicedToArray(_React$useState47, 2),
    nestedFiltersHasPreselectedTags = _React$useState48[0],
    setNestedFiltersHasPreselectedTags = _React$useState48[1];
  var _React$useState49 = React.useState(null),
    _React$useState50 = _slicedToArray(_React$useState49, 2),
    activePopupItem = _React$useState50[0],
    setActivePopupItem = _React$useState50[1];
  var _React$useState51 = React.useState([]),
    _React$useState52 = _slicedToArray(_React$useState51, 2),
    activeTopPicks = _React$useState52[0],
    setActiveTopPicks = _React$useState52[1];
  var checkboxes = React.useRef(null);
  var defaultTypeValues = React.useRef([]);
  var requestSettingsForSearch = React.useRef({
    facets: [],
    facetFilters: null,
    index: ''
  });
  var host = canUseDOM ? window.location.hostname : '';
  var prevChosenType = usePrevious(chosenTypes);
  var showLabel = getDictionaryItem(dictionary, 'Show') || 'show';
  var resultsLabel = getDictionaryItem(dictionary, 'Results') || 'results';
  var clearAllLabel = getDictionaryItem(dictionary, 'ClearAll') || 'clear all';
  var selectAllLabel = getDictionaryItem(dictionary, 'ShowAll') || 'show all';
  var Cancel = getDictionaryItem(dictionary, 'Cancel') || 'cancel';
  var FiltersCopy = getDictionaryItem(dictionary, 'Filters') || 'filters';
  var day = getDictionaryItem(dictionary, 'Day') || 'day';
  var days = getDictionaryItem(dictionary, 'Days') || 'days';
  var noItemsInLisitng = getDictionaryItem(dictionary, 'noItemsInLisitng') || 'no items in the list';
  var viewAsList = getDictionaryItem(dictionary, 'viewAsList') || 'view as listing';
  var viewMoreAsList = getDictionaryItem(dictionary, 'viewMoreAsList') || 'view more as as list';
  var viewAsMap = getDictionaryItem(dictionary, 'viewAsMap') || 'view as map';
  var listingTitleCommon = getDictionaryItem(dictionary, 'listingTitleCommon') || 'popular around the city';
  var listingTitleSelected = getDictionaryItem(dictionary, 'listingTitleSelected') || "Dicsover's dubai's {count}";
  var lbResultsForDictionary = getDictionaryItem(dictionary, 'lbResultsFor') || 'Results for';
  var lbNoResultsDictionary = getDictionaryItem(dictionary, 'lbNoResults') || 'We could not find any results.';
  var placeholderDictionary = getDictionaryItem(dictionary, 'placeholder') || 'Start typing...';
  var search = {
    IndexName: {
      value: mainSearchIndex
    },
    targetItem: {
      lbResultsFor: {
        value: lbResultsForDictionary
      },
      lbNoResults: {
        value: lbNoResultsDictionary
      },
      placeholder: {
        value: placeholderDictionary
      },
      hitsPerPage: {
        value: mainHitsPerPage
      },
      indexName: {
        value: mainSearchIndex
      }
    }
  };
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var variables = BackgroundColorHex ? {
    '--m113-interactive-map-background-color': BackgroundColorHex,
    '--m113-interactive-map-background-active-color': ActiveColorHex,
    '--m113-interactive-map-color': ColorHex
  } : {
    '--m113-interactive-map-background-color': selectedPrimaryColor,
    '--m113-interactive-map-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m113-interactive-map-color': getColorByTheme(selectedPrimaryColor)
  };
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  var generateSearchIndex = function generateSearchIndex(index) {
    return "".concat(getHostName(host)).concat(index, "_").concat(language);
  };
  var getCategorySearchIndex = function getCategorySearchIndex() {
    return chosenTypes.length > 1 ? generateSearchIndex(mainSearchIndex) : chosenTypes[0].searchIndex;
  };
  var searchIndexParams = chosenTypes.length ? getCategorySearchIndex() : generateSearchIndex(mainSearchIndex);
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
    if (canUseDOM) {
      var topPicks = getTopPicksStorage();
      var topPicksList = topPicks.list || [];
      setActiveTopPicks(topPicksList.map(function (el) {
        return el.itemId;
      }));
    }
  }, []);

  // START  CATEGORY LOGIC

  var queryParams = qsToObject(location.search);
  if (Object.keys(queryParams).length !== 0) {
    for (var key in queryParams) {
      queryParams[key] = replaceUrlPluses(queryParams[key], key === 'tags' || key === 'itineraryDatesRange') || queryParams[key];
    }
  }
  var facetFilters = convertQueryParamsToFacetsWithoutPlusReplacement(queryParams, true, nestedFilters);
  var algoliaIndexes = chosenTypes.length ? getCategorySearchIndex() : generateSearchIndex(mainSearchIndex);
  var getAllFacetsNames = function getAllFacetsNames() {
    var allFacetsNames = [filterType];
    if (categories.length) {
      categories.map(function (el) {
        var categoriesFacetsArray = el.filters.values ? getFacetNamesValue(el.filters) : [];
        allFacetsNames = [].concat(_toConsumableArray(allFacetsNames), _toConsumableArray(categoriesFacetsArray));
      });
    }
    return allFacetsNames;
  };
  var handleCategoryQuery = function handleCategoryQuery() {
    var removeAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var selectedCheckboxesUrl = [];
    var allFacets = getAllFacetsNames();
    selectedCheckboxesUrl = chosenTypes.map(function (el) {
      return el.value;
    }).join(splitter);
    if (removeAll) {
      allFacets.filter(function (value, index) {
        return allFacets.indexOf(value) === index;
      }).forEach(function (type) {
        removeQueryString(type, history);
      });
    } else {
      if (selectedCheckboxesUrl.length) {
        addQueryString(filterType, replaceUrlPluses(selectedCheckboxesUrl), history);
      } else {
        removeQueryString(filterType, history);
      }
    }
  };
  var listingRequest = function listingRequest(itemFilters) {
    var getDefaultFacets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    setLoading(true);
    var pageNumber = 1;
    var promisesQueue = [];
    var finalResponse = [];
    if (getDefaultFacets) {
      getListing(algoliaIndexes, itemFilters).then(function (response) {
        setdefaultFacets(response.facets);
      }).then(function () {
        setTimeout(function () {
          return setLoading(false);
        }, 1000);
      });
    } else {
      getListing(algoliaIndexes, itemFilters).then(function (response) {
        if (response.hits) {
          applySetFilters(false);
          setResult(response);
          setFacets(response.facets);
          // setdefaultFacets(response.facets);
          setFacetsStats(response && response.facets_stats);
          setNbHits(response.nbHits);
          setNbPages(response.nbPages);
          finalResponse = _toConsumableArray(response.hits);
          finalResponse = finalResponse.filter(function (el) {
            return el._geoloc && el.objectID;
          });
          setHits(finalResponse);
          setAllHits(finalResponse);
          setListingHits(finalResponse);

          // nbPages - max available items per page
          if (pageNumber < response.nbPages) {
            // create array of promisses
            for (var i = 1; i < response.nbPages; i++) {
              var itemFilterCopy = _objectSpread({}, itemFilters);
              itemFilterCopy.page = i;
              promisesQueue.push(itemFilterCopy);
            }
            if (promisesQueue.length) {
              Promise.all(promisesQueue.map(function (item) {
                getListing(algoliaIndexes, item).then(function (responses) {
                  // summarize all the hits by all request
                  finalResponse = [].concat(_toConsumableArray(finalResponse), _toConsumableArray(responses.hits));
                  finalResponse = finalResponse.filter(function (el) {
                    return el._geoloc && el.objectID;
                  });
                }).then(function () {
                  setHits(finalResponse);
                  setAllHits(finalResponse);
                  setListingHits(finalResponse);
                  setTimeout(function () {
                    return setLoading(false);
                  }, 1000);
                }).catch(function (error) {
                  console.log(error);
                });
              }));
            }
          }
        }
      }).then(function () {
        setTimeout(function () {
          return setLoading(false);
        }, 1000);
        setResetAllFilters(false);
      });
    }
  };
  var handleCategorAllRequest = function handleCategorAllRequest() {
    var facetFiltersFromCategory = chosenTypes.length ? chosenTypes.map(function (el) {
      return "type: ".concat(el.value);
    }) : defaultTypeValues.current.map(function (el) {
      return "type: ".concat(el.value);
    });
    var itemFilters = {
      facets: [filterType],
      filters: 'isGeoloc:true',
      facetFilters: [_toConsumableArray(facetFiltersFromCategory)],
      hitsPerPage: pagesize,
      page: 0
    };
    listingRequest(itemFilters);
    requestSettingsForSearch.current = {
      facets: [filterType],
      facetFilters: [_toConsumableArray(facetFiltersFromCategory)],
      index: searchIndexParams
    };
    handleCategoryQuery(true);
    setRemoveFilterLogic(false);
  };
  React.useEffect(function () {
    if (!withMapModalView && categories.length) {
      var defaultItems = _toConsumableArray(categories);
      defaultTypeValues.current = defaultItems.map(function (el) {
        var item = {
          searchIndex: generateSearchIndex(get(el, 'searchIndex.jss.fields.IndexName.value') || ''),
          value: get(el, 'contentType.type.template.targetItem.value') || '',
          nestedFilters: get(el, 'filters') || [],
          color: get(el, 'colourTheme.item.backgroundColor.jss.value') || 'var(--m113-interactive-map-background-color)'
        };
        return item;
      });
      handleCategorAllRequest();
    }
  }, []);
  React.useEffect(function () {
    if (removeFilterLogic) {
      handleCategorAllRequest();
    }
  }, [removeFilterLogic]);
  var getFacetFiltersFromTypes = function getFacetFiltersFromTypes() {
    return chosenTypes.length ? chosenTypes.map(function (el) {
      return "type: ".concat(el.value);
    }) : defaultTypeValues.current.map(function (el) {
      return "type: ".concat(el.value);
    });
  };
  var hasPreselectedTags = function hasPreselectedTags(nestedItems) {
    var itemsWithPreselectedTags = nestedItems.filter(function (item) {
      return item.preselectedTags && item.preselectedTags.values.length;
    });
    setNestedFiltersHasPreselectedTags(itemsWithPreselectedTags.length ? true : false);
  };
  var submitFilters = function submitFilters(e, key, index, nestedFilters) {
    handleCategoryQuery(true);
    var selectedItem = {
      searchIndex: generateSearchIndex(e.target.getAttribute('data-search-index') || ''),
      value: e.target.value,
      nestedFilters: nestedFilters.values ? nestedFilters : {
        values: []
      },
      title: e.target.getAttribute('data-mainTitle') || ''
    };
    if (chosenTypes.find(function (el) {
      return el.value === selectedItem.value;
    })) {
      var items = chosenTypes.filter(function (el) {
        return el.value !== selectedItem.value;
      });
      //uncheck categories
      setChosenTypes(items);
      setNestedFilters({
        values: []
      });
      hasPreselectedTags([]);
      setRemoveFilterLogic(true);
    } else {
      //check categories
      setChosenTypes([selectedItem]);
      hasPreselectedTags(selectedItem.nestedFilters.values);

      // filterData  TO DO ADD CHECK FOR NULL
      setNestedFilters(selectedItem.nestedFilters);
    }
    setFirstLoad(false);
  };

  // END  CATEGORY LOGIC

  React.useEffect(function () {
    if (!firstLoad) {
      var queryIndexes = Object.keys(queryParams).filter(function (k) {
        return k.indexOf("".concat(searchIndexParams, "_asc_")) > -1;
      })[0];
      var _algoliaIndexes = '';
      if (queryIndexes) {
        _algoliaIndexes = queryIndexes;
      } else {
        _algoliaIndexes = get(params, 'SearchIndex');
      }
      var tag = 'tags:';
      if (canUseDOM) {
        var hash = window.location.hash;
        var hashvalue = hash.split('#tag=');
        if (hashvalue[1]) {
          tag = 'tags:' + decodeURI(hashvalue[1]);
        }
      }
      var types = getFacetFiltersFromTypes();
      // filterData
      var facetNames = getFacetNamesValue(nestedFilters);
      var filters;
      if (queryParams.datesRange) {
        filters = queryParams.datesRange.split('+').join(' ');
      } else {
        var filterValues = getAlgoliaTagsList(nestedFilters);
        if (filterValues.indexOf(eventDatesRange) > -1) {
          filters = "datesRange.to > ".concat(Date.parse(new Date()) / 1000);
        }
        if (~filterValues.indexOf(ANNUAL_FEE) && queryParams[ANNUAL_FEE]) {
          filters = "".concat(queryParams[ANNUAL_FEE]).split('+').join(' ');
        }
        var filtersData = [];
        if (filterValues.indexOf('totalHotelRooms') > -1 && queryParams['totalHotelRooms']) {
          filtersData.push("totalHotelRooms ".concat(queryParams['totalHotelRooms'].split('+').join(' ')));
        }
        if (filtersData.length) {
          filters = filtersData.map(function (query) {
            return "(".concat(query, ")");
          }).join(' AND ');
        }
      }
      if (queryParams.valid) {
        filters = queryParams.valid.split('+').join(' ');
      }
      var itemFilters;
      if (filters) {
        itemFilters = {
          filters: filters ? 'AND (isGeoloc:true)' : 'isGeoloc:true',
          facets: [].concat(_toConsumableArray(facetNames), [filterType]),
          facetFilters: [_toConsumableArray(types)].concat(_toConsumableArray(facetFilters), [[tag]]),
          hitsPerPage: pagesize,
          page: 0
        };
      } else {
        itemFilters = {
          facets: [].concat(_toConsumableArray(facetNames), [filterType]),
          filters: 'isGeoloc:true',
          facetFilters: [_toConsumableArray(types)].concat(_toConsumableArray(facetFilters), [[tag]]),
          hitsPerPage: pagesize,
          page: 0
        };
      }
      requestSettingsForSearch.current = {
        facets: [filterType],
        facetFilters: [_toConsumableArray(types)],
        index: searchIndexParams
      };
      if (resetAllFilters) {
        listingRequest(itemFilters);
      } else if (setFilters) {
        listingRequest(itemFilters);
      } else if (chosenTypes.length && !nestedFiltersHasPreselectedTags && !setFilters) {
        if (JSON.stringify(chosenTypes) !== JSON.stringify(prevChosenType)) {
          itemFilters = {
            facets: [].concat(_toConsumableArray(facetNames), [filterType]),
            facetFilters: [_toConsumableArray(types), [tag]],
            hitsPerPage: pagesize,
            page: 0
          };
          listingRequest(itemFilters);
        }
      }
    }
  }, [resetAllFilters, resetFilter, setFilters, chosenTypes]);
  React.useEffect(function () {
    //get dafault facets

    if (chosenTypes.length) {
      var tag = 'tags:';
      if (canUseDOM) {
        var hash = window.location.hash;
        var hashvalue = hash.split('#tag=');
        if (hashvalue[1]) {
          tag = 'tags:' + decodeURI(hashvalue[1]);
        }
      }
      var types = getFacetFiltersFromTypes();
      // filterData
      var facetNames = getFacetNamesValue(nestedFilters);
      listingRequest({
        facets: [].concat(_toConsumableArray(facetNames), [filterType]),
        filters: 'isGeoloc:true',
        facetFilters: [_toConsumableArray(types), [tag]],
        hitsPerPage: 1,
        page: 0
      }, true);
    }
  }, [chosenTypes]);
  var resetFilterCallback = function resetFilterCallback() {
    setFacets(undefined);
    setResult(undefined);
    setNbHits(0);
    setHits([]);
    setListingHits([]);
    setpage(0);
    setResetFilter(true);
  };
  var resetAllFiltersCallback = function resetAllFiltersCallback() {
    setResetAllFilters(true);
  };

  //when nested filters applies
  var setListingFilter = function setListingFilter() {
    setpage(0);
    setHits([]);
    setListingHits([]);
    applySetFilters(true);
    // setdefaultFacets(result && result.facets);
    setFacetsStats(result && result.facets_stats);
  };
  var updateLocation = function updateLocation() {
    var defaultLat = Number(centreMapLatitude);
    var defaultLng = Number(centreMapLongitude);
    var markers = [];
    if (hits.length) {
      markers = hits.map(function (el) {
        el.color = getItemColor(el, defaultTypeValues.current);
        return el;
      });
    }
    setMapState({
      lat: defaultLat,
      lng: defaultLng,
      markers: markers
    });
  };
  React.useEffect(function () {
    if (mapApiReady && !loading) {
      updateLocation();
    }
  }, [mapApiReady, loading, hits]);
  React.useEffect(function () {
    if (!allowSearch && !firstLoad) {
      handleCategorAllRequest();
    }
    if (canUseDOM) {
      var bodyElement = canUseDOM ? document.querySelector('body') : null;
      var htmlElement = canUseDOM ? document.querySelector('html') : null;
      if (bodyElement) {
        if (allowSearch) {
          bodyElement.classList.add('prevent-scroll');
        } else {
          bodyElement.classList.remove('prevent-scroll');
        }
      }
      if (htmlElement) {
        if (allowSearch) {
          htmlElement.classList.add('prevent-scroll');
        } else {
          htmlElement.classList.remove('prevent-scroll');
        }
      }
    }
  }, [allowSearch]);
  var _handleResetFiltersFromSearch = function handleResetFiltersFromSearch() {
    setChosenTypes([]);
    setResetAllFilters(true);
    setNestedFilters({
      values: []
    });
    setRemoveFilterLogic(true);
  };
  var _handleDisableNestedFiltersFromSearch = function handleDisableNestedFiltersFromSearch() {
    if (chosenTypes.length !== 0) {
      setChosenTypes([]);
      setNestedFilters({
        values: []
      });
    }
  };
  var _filterPinsBySearch = function filterPinsBySearch(searchQuery) {
    if (searchQuery) {
      var searchWords = searchQuery.trim().toLowerCase().split(' ');
      var filteredArticles = allHits.filter(function (hit) {
        return searchWords.some(function (word) {
          return hit.title && hit.title.toLowerCase().includes(word) || hit.introText && hit.introText.toLowerCase().includes(word);
        });
      });
      console.info(filteredArticles);
      setHits(filteredArticles);
    }
  };
  var _handleGetHitsFromMap = function handleGetHitsFromMap(mapItemsInViewPort) {
    var loadedItemsFromMap = mapItemsInViewPort.filter(function (el) {
      return el.data;
    }).map(function (el) {
      return el.data;
    });
    var updatedListingHits = moveObjectToFirstPlace(loadedItemsFromMap, function (hit) {
      return hit.objectID === activeListingItemId;
    });
    setListingHits(loadedItemsFromMap.length ? updatedListingHits : hits);
  };
  var _handleGetActiveItemId = function handleGetActiveItemId(id) {
    setActiveListingItemId(id);
  };
  var apiReady = function apiReady() {
    setMapApiReady(true);
  };
  var getActivePopupOnMap = function getActivePopupOnMap(item) {
    setActivePopupItem(item);
  };
  var _toggleActiveTopPicks = function toggleActiveTopPicks(objectId) {
    var id = idConverter(objectId);
    var topPicks = getTopPicksStorage();
    var topPicksList = topPicks.list || [];
    var list = _toConsumableArray(topPicksList.map(function (el) {
      return el.itemId;
    }));
    if (list.includes(id)) {
      var index = list.indexOf(id);
      if (index > -1) {
        list.splice(index, 1);
      }
    } else {
      list.push(id);
    }
    setActiveTopPicks(list);
  };
  if (fields && !fields.data) {
    console.info('InteractiveMap: check fields.data settings');
    return /*#__PURE__*/React.createElement("div", {
      className: "no-data"
    }, " [InteractiveMap component: something went wrong]");
  }
  if (fields && fields.data && !fields.data.datasource) {
    console.info('InteractiveMap: check fields.data.item settings');
    return /*#__PURE__*/React.createElement("div", {
      className: "no-data"
    }, " [InteractiveMap component: something went wrong]");
  }
  if (!fields) {
    console.info('InteractiveMap component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [InteractiveMap component is empty: please provide data source]");
    }
    return null;
  }
  var leftBar = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InteractiveMapFilters, {
    params: params,
    categories: categories,
    analytics: eventsAnalytics,
    withMapModalView: withMapModalView,
    submitFilters: submitFilters,
    mainTitle: mainTitle,
    rtl: rtl,
    chosenTypes: chosenTypes,
    fields: nestedFilters,
    facets: facets,
    defaultFacets: defaultFacets,
    facetsStats: facetsStats,
    showLabel: showLabel,
    resultsLabel: resultsLabel,
    nbHits: nbHits,
    clearAllLabel: clearAllLabel,
    selectAllLabel: selectAllLabel,
    setListingFilter: setListingFilter,
    resetFilterCallback: resetFilterCallback,
    day: day,
    days: days,
    Cancel: Cancel,
    FiltersCopy: FiltersCopy,
    isTagPage: false,
    lang: currentLang,
    hits: hits,
    dictionary: dictionary,
    imageDictionary: imageDictionary,
    firstQuery: facetFilters.length !== 0 ? facetFilters[facetFilters.length - 1][0].split(':')[0] : '',
    resetAllFiltersCallback: resetAllFiltersCallback,
    searchIndex: searchIndexParams,
    isNestedFilters: true,
    search: search,
    requestSettingsForSearch: requestSettingsForSearch.current,
    allowSearch: allowSearch,
    handleAllowSearch: function handleAllowSearch(value) {
      return setAllowSearch(value);
    },
    defaultTypeValues: defaultTypeValues.current,
    handleResetFiltersFromSearch: function handleResetFiltersFromSearch() {
      return _handleResetFiltersFromSearch();
    },
    activeListingItemId: activeListingItemId,
    handleDisableNestedFiltersFromSearch: function handleDisableNestedFiltersFromSearch() {
      return _handleDisableNestedFiltersFromSearch();
    },
    filterPinsBySearch: function filterPinsBySearch(searchQuery) {
      return _filterPinsBySearch(searchQuery);
    },
    getActivePopupOnMap: getActivePopupOnMap,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: function toggleActiveTopPicks(objectId) {
      return _toggleActiveTopPicks(objectId);
    }
  }), !allowSearch && /*#__PURE__*/React.createElement(CategoryFilters, {
    analytics: eventsAnalytics,
    params: params,
    categories: categories,
    chosenTypes: chosenTypes,
    checkboxesRef: checkboxes,
    withMapModalView: withMapModalView,
    submitFilters: submitFilters,
    rtl: rtl
  }), !allowSearch && /*#__PURE__*/React.createElement(InteractiveMapListing, {
    analytics: eventsAnalytics,
    params: params,
    listingItems: listingHits,
    hits: hits,
    defaultTypeValues: defaultTypeValues.current,
    rtl: rtl,
    noItemsDictionary: noItemsInLisitng,
    viewAsListingDictionary: viewAsList,
    viewMoreAsListingDictionary: viewMoreAsList,
    viewAsMapDictionary: viewAsMap,
    listingTitleCommonDictionary: listingTitleCommon,
    listingTitleSelectedDictionary: listingTitleSelected,
    chosenTypes: chosenTypes,
    mainHitsPerPage: mainHitsPerPage,
    activeListingItemId: activeListingItemId,
    loading: loading,
    getActivePopupOnMap: getActivePopupOnMap,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: function toggleActiveTopPicks(objectId) {
      return _toggleActiveTopPicks(objectId);
    }
  }));
  var rightBar = /*#__PURE__*/React.createElement(InteractiveGoogleMap, {
    mapState: mapState,
    callback: apiReady,
    handleGetHitsFromMap: function handleGetHitsFromMap(hits) {
      return _handleGetHitsFromMap(hits);
    },
    handleGetActiveItemId: function handleGetActiveItemId(id) {
      return _handleGetActiveItemId(id);
    },
    dictionary: dictionary,
    defaultMapZoom: defaultMapZoom,
    centreMapLatitude: centreMapLatitude,
    centreMapLongitude: centreMapLongitude,
    analytics: eventsAnalytics,
    params: params,
    rtl: rtl,
    activePopupItem: activePopupItem,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: function toggleActiveTopPicks(objectId) {
      return _toggleActiveTopPicks(objectId);
    }
  });
  return /*#__PURE__*/React.createElement(InteractiveMapLayout, {
    params: params,
    rtl: rtl,
    loading: loading,
    leftBar: leftBar,
    rightBar: rightBar,
    stylesVariables: variables,
    allowSearch: allowSearch
  });
};
export default InteractiveMap;